<template>
    <div class="s-financialApplyForRules-container container">
        <topNav></topNav>
        <div class="content w1300 marginAuto">
            <div class="crumbs">
                <img src="../assets/image/index/home.png" class="img" alt="">
                <span v-if="showCrumbs == 'index'" @click="goRoute('index')" class="go">首页&gt;</span>
                <span @click="goRoute('financialInsurance')" class="go">金融保险&gt;</span>
                <span>金融服务申请</span>
            </div>
            <div class="rules">
                <div class="title">中国农业银行个人农业贷款</div>
                <div class="childTitle">产品说明：</div>
                <div class="ruleContent">
                    个人消费类汽车贷款是指借款人在购买消费类自用车（不含二手车）时已支付一定比例金额的首期款项、不足部分由银行向其发放并直接支付给汽车经销商的人民币贷款。
                </div>
                <div class="childTitle">一、贷款条件</div>
                <div class="ruleContent">
                    <p>1、具有完全民事行为能力的自然人；</p>
                    <p>2、个人身份有效证明；</p>
                    <p>3、具有合法的足够偿还贷款本息的能力；</p>
                    <p>4、个人信用良好；</p>
                    <p>5、持有经办行认可的购车合同、协议或购车意向书；</p>
                    <p>6、提供经办行认可的抵/ 质押物或有足够代偿能力的个人或单位提供第三方不可撤销的连带责任保证；或提供满足《中国银行个人信用循环贷款额度暂行管理办法》客户准入条件的相应资料；</p>
                    <p>7、能够支付本办法规定限额的首期购车款能力证明；</p>
                    <p>8、经办行规定的其他条件。</p>
                </div>
                <div class="childTitle">二、贷款申请</div>
                <div class="ruleContent">
                    <p>申请个人消费汽车贷款业务需提供的材料：</p>
                    <p>（一）借款申请书；</p>
                    <p>（二）身份证、户口簿或其他有效居留证件原件，并提供其复印件；</p>
                    <p>（三）职业和经济收入证明，包括但不限于单位开具的收入证明、银行存单、信用卡对账单、纳税证明等；</p>
                    <p>（四）与经销商签订的购车协议、合同或者购车意向书；</p>
                    <p>（五）担保所需的证明或文件，包括抵（质）押物清单和有处分权人（含财产共有人）同意抵、质押的证明；有权部门出具的抵押物所有权或使用权证明、书面估价证明（车辆发票价格结合市场公布价格所做的书面估价）、同意保险的文件；质押物需交付质押物或权利证明文件；保证人同意履行连带责任保证的保证合同、有关资信证明材料；或满足信用贷款条件的证明文件；</p>
                    <p>（六）已缴付首期购车款的相关证明；</p>
                    <p>（七）分行要求提供的其他文件资料。</p>
                </div>
                <div class="childTitle">三、贷款限额</div>
                <div class="ruleContent">
                    一般客户贷款限额原则上不高于汽车价格的60％，由优质客户提供担保的原则上不高于汽车价格的70%;优质客户贷款限额原则上不高于汽车价格的70％。
                </div>
                <div class="childTitle">四、贷款期限</div>
                <div class="ruleContent">
                    一般客户个人汽车消费贷款期限原则上不应超过3年（含3年）; 优质客户个人汽车消费贷款期限最长不超过5年（含5年）。
                </div>
                <div class="childTitle">五、贷款利率</div>
                <div class="ruleContent">
                    根据贷款期限长短按中国人民银行公布的相应档次贷款利率执行，一般客户贷款利率执行基准利率，原则上不得低于基准利率; 优质客户贷款利率经省级分行批准，可以在基准利率基础上适当下浮，下浮比例不得超过10％。
                </div>
                <div class="childTitle">六、贷款币种</div>
                <div class="ruleContent">
                    目前仅限于人民币。
                </div>
                <div class="childTitle">七、贷款担保</div>
                <div class="ruleContent">
                    <p>（一）借款人需提供足值、有效的担保，作为可靠的第二还款来源。其中，一般客户必须提供下列任两种担保方式，优质客户可以提供下列任一种担保方式。</p>
                     <p>1、所购车辆抵押 </p>
                     <p>2、第三方（自然人或法人）不可撤销的连带责任担保</p>
                     <p>3、除所购车辆外的财产抵/质押 </p>
                     <p>4、总行认可的其他担保方式 </p>
                     <p>（二）对于满足《中国银行个人信用循环贷款额度暂行管理办法》客户准入条件的消费类汽车贷款优质客户，可以采用信用贷款的方式。</p>
                     <p>（三）贷款担保应严格按照《担保法》等相关法律法规及我行现行抵/质押担保的有关规定进行管理。</p>
                </div>
            </div>
            <div class="btn">
                <el-button size="mini" class="applyForBtn" @click="goRoute('financialInsuranceApplyFor',true)">开始申请</el-button>
            </div>
        </div>
        <footerNav></footerNav>
    </div>
</template>

<script>
    import topNav from "../components/topNav.vue";
    import footerNav from "../components/footerNav.vue";

    export default {
        name:'financialApplyForRules',
        components: { topNav ,footerNav},
        data(){
            return {
                showCrumbs:'financialInsurance'
            }
        },
        created(){
            if(this.$route.query.from){
                if(this.$route.query.from == 'index'){
                    this.showCrumbs = 'index'
                }else if(this.$route.query.from == 'financialInsurance'){
                    this.showCrumbs = 'financialInsurance'
                }
            }
        },
        mounted(){

        },
        methods:{
            goRoute(url,type){
                if(type){
                    this.$router.push({ path: url,query:{from:this.showCrumbs}});
                }else{
                    this.$router.push({ path: url});
                }
                
            }
        }
    }
</script>


<style lang="scss">
@import "../utils/css/common.scss";
.s-financialApplyForRules-container{
    .applyForBtn{
        background:-webkit-linear-gradient(to right, #1CBA4D, #A1DC61); 
        background: -o-linear-gradient(right,#1CBA4D,#A1DC61);
        background: -ms-linear-gradient(right,#1CBA4D,#A1DC61);
        background: -moz-linear-gradient(right, #1CBA4D, #A1DC61);
        background:linear-gradient(to right,#1CBA4D,#A1DC61);
        border-radius: 6px;
        font-size: 18px;
        font-family: PingFangSC;
        color: #FFFFFF;
        line-height: 18px;
    }
}

</style>
<style lang="scss" scoped>
.s-financialApplyForRules-container{
    background-color: #F8F8F8;
    .content{
        min-height: 630px;
        margin-top: 110px;
        .crumbs{
            line-height: 50px;
            .img{
                width: 27px;
                height: 29px;
                float: left;
                margin-right: 10px;
                margin-top: 8px;
            }
            span{
                font-size: 16px;
                font-family: PingFangSC;
                font-weight: 500;
                color: #333333;
                line-height: 50px;
            }
            .go{
                cursor: pointer;
            }
        }
        .rules{
            .title{
                font-size: 24px;
                font-family: PingFangSC;
                font-weight: 600;
                color: #333333;
                line-height: 80px;
                text-align: center;
            }
            .childTitle{
                font-size: 18px;
                font-family: PingFangSC;
                font-weight: 600;
                color: #000000;
                line-height: 40px;
            }
            .ruleContent{
                font-size: 18px;
                font-family: PingFangSC;
                font-weight: 400;
                color: #262626;
                line-height: 40px;
                p{
                    font-size: 18px;
                    font-family: PingFangSC;
                    font-weight: 400;
                    color: #262626;
                    line-height: 40px;
                }
            }
        }
        .btn{
            text-align: center;
            margin-top:30px;
            margin-bottom: 50px;
        }
    }
}
</style>